export default __webpack_public_path__ + "media/images/elements/samsung-gear-775f172e8cb1bf45c5348fda13a15dd8.png";